import React, { useEffect, useMemo, useState } from 'react';
import { GraphFlowEditor } from '../../../graph-workflow-editor';
import { MISSION_CONTROL_DEMO_GRAPH } from '../constants/demoGraph';
import LaneLabelNode from '../atoms/LaneLabelNode';

const FLOW_SEQUENCE = [
  'lane1-preflight',
  'lane1-execute',
  'lane1-script',
  'lane2-preflight',
  'lane2-execute',
  'lane2-script',
  'lane3-preflight',
  'lane3-execute',
  'lane3-script',
];

const FLOW_TICK_MS = 1200;

const MissionControlCanvas = () => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setActiveStep((prev) => (prev + 1) % FLOW_SEQUENCE.length);
    }, FLOW_TICK_MS);

    return () => window.clearInterval(intervalId);
  }, []);

  const nodeTypes = useMemo(
    () => ({
      laneLabel: LaneLabelNode,
    }),
    []
  );

  const animatedNodes = useMemo(
    () =>
      MISSION_CONTROL_DEMO_GRAPH.nodes.map((node) => {
        if (node.type !== 'workflowNode') return node;

        const sequenceIndex = FLOW_SEQUENCE.indexOf(node.id);
        if (sequenceIndex === -1) return node;

        let status = 'pending';
        if (sequenceIndex < activeStep) status = 'completed';
        if (sequenceIndex === activeStep) status = 'running';

        return {
          ...node,
          data: {
            ...node.data,
            status,
          },
        };
      }),
    [activeStep]
  );

  return (
    <div className="mc-demo-canvas-shell">
      <GraphFlowEditor
        graphType="run_test"
        initialNodes={animatedNodes}
        initialEdges={MISSION_CONTROL_DEMO_GRAPH.edges}
        nodeConfigs={MISSION_CONTROL_DEMO_GRAPH.nodeConfigs}
        stateSchema={MISSION_CONTROL_DEMO_GRAPH.stateSchema}
        showResetPanel={false}
        showGraphInfoPanel={false}
        backgroundVariant="lines"
        backgroundGap={40}
        backgroundLineWidth={0.35}
        backgroundColor="rgba(255,255,255,0.08)"
        defaultZoomMultiplier={0.66}
        customNodeTypes={nodeTypes}
        syncFromProps
      />
    </div>
  );
};

export default MissionControlCanvas;
